import { render, staticRenderFns } from "./scopri-area-riservata.vue?vue&type=template&id=353522c2"
import script from "./scopri-area-riservata.vue?vue&type=script&lang=js"
export * from "./scopri-area-riservata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports